/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import Popup from '../../Popup';

class ScorePostedConfirmationPopup extends Component {
    render() {
        const { onCtaClick, invitees, clubPost, playerMatchPost, flexLeagueMatchPostScore } = this.props;
        const arePlayersInvited = invitees && invitees.length > 0;
        const noOfInvites = arePlayersInvited ? invitees.length : 0;
        const playerPost = playerMatchPost && flexLeagueMatchPostScore
            ? (
                <React.Fragment>
                    <p>
                        Your score is now waiting for <b>confirmation from your opponent.</b> Once they confirm, it&apos;ll display on your player profile, and your ratings will update overnight. If they don&apos;t take action, the score will <b>automatically confirm in 4 days</b>.
                    </p>
                    <div className="mt24 text-error">
                        Warning: UTR Sports reserves the right to disable your ability to post scores and/or suspend your account if false or inaccurate scores are reported.
                    </div>
                </React.Fragment>
            )
            : (
                <React.Fragment>
                    <p>
                        Once your opponent(s) review and confirm the score, it will display publicly on your player profiles and ratings will update by the next day. You can delete the score if you made a mistake and/or want it taken off UTR Sports.
                    </p>
                    <p className="mt16">
                        Scores posted for Verified matches will be reviewed by UTR Sports and converted to Verified UTR Rating scores within a week
                    </p>
                    <div className="mt24 text-error">
                        Warning: UTR Sports reserves the right to disable your ability to post scores and/or suspend your account if you post false or inaccurate scores.
                    </div>
                </React.Fragment>
            );

        return (
            <Popup
                className="popup-md"
                onCloseClick={() => {
                    onCtaClick();
                }}
                config={{
                    fullScreen: false,
                    noPadding: true,
                    scrollable: false,
                }}
            >
                <div className="popup-section p24 pt0">
                    <h5>Score Posted!</h5>
                </div>
                <div className="popup-section p24 pt0">
                    <p>
                        {arePlayersInvited ? (
                            <React.Fragment>
                                {
                                    `Once your ${noOfInvites === 1 ? 'opponent joins' : 'opponents join'} and confirms the result, it will be publicly posted on profiles and ratings will update by the next day.`
                                }
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                {clubPost
                                    ? 'Score has been posted to player profiles and ratings will update by next day.'
                                    : playerPost}
                            </React.Fragment>
                        )}
                    </p>
                    <div className="row">
                        <div className="col-md-6 mt24">
                            <button
                                className="btn btn-default text-uppercase btn-block"
                                type="button"
                                onClick={() => {
                                    onCtaClick();
                                }}
                            >
                                Exit
                            </button>
                        </div>
                        <div className="col-md-6 mt24">
                            <button
                                className="btn btn-primary text-uppercase btn-block"
                                type="button"
                                onClick={() => {
                                    onCtaClick('next');
                                }}
                            >
                                Post Another Score
                            </button>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

export default ScorePostedConfirmationPopup;
